var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePayMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "G_Pay_Acceptance_Mark",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1094 742",
    enableBackground: "new 0 0 1094 742",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Base_1_",
    fill: "#FFFFFF",
    d: "M722.7,170h-352c-110,0-200,90-200,200l0,0c0,110,90,200,200,200h352c110,0,200-90,200-200l0,0  C922.7,260,832.7,170,722.7,170z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Outline",
    fill: "#3C4043",
    d: "M722.7,186.2c24.7,0,48.7,4.9,71.3,14.5c21.9,9.3,41.5,22.6,58.5,39.5  c16.9,16.9,30.2,36.6,39.5,58.5c9.6,22.6,14.5,46.6,14.5,71.3s-4.9,48.7-14.5,71.3c-9.3,21.9-22.6,41.5-39.5,58.5  c-16.9,16.9-36.6,30.2-58.5,39.5c-22.6,9.6-46.6,14.5-71.3,14.5h-352c-24.7,0-48.7-4.9-71.3-14.5c-21.9-9.3-41.5-22.6-58.5-39.5  c-16.9-16.9-30.2-36.6-39.5-58.5c-9.6-22.6-14.5-46.6-14.5-71.3s4.9-48.7,14.5-71.3c9.3-21.9,22.6-41.5,39.5-58.5  c16.9-16.9,36.6-30.2,58.5-39.5c22.6-9.6,46.6-14.5,71.3-14.5L722.7,186.2 M722.7,170h-352c-110,0-200,90-200,200l0,0  c0,110,90,200,200,200h352c110,0,200-90,200-200l0,0C922.7,260,832.7,170,722.7,170L722.7,170z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "G_Pay_Lockup_1_"
  }, "\n&#x9;", /*#__PURE__*/React.createElement("g", {
    id: "Pay_Typeface_3_"
  }, "\n&#x9;&#x9;", /*#__PURE__*/React.createElement("path", {
    id: "Letter_p_3_",
    fill: "#3C4043",
    d: "M529.3,384.2v60.5h-19.2V295.3H561c12.9,0,23.9,4.3,32.9,12.9    c9.2,8.6,13.8,19.1,13.8,31.5c0,12.7-4.6,23.2-13.8,31.7c-8.9,8.5-19.9,12.7-32.9,12.7h-31.7V384.2z M529.3,313.7v52.1h32.1    c7.6,0,14-2.6,19-7.7c5.1-5.1,7.7-11.3,7.7-18.3c0-6.9-2.6-13-7.7-18.1c-5-5.3-11.3-7.9-19-7.9h-32.1V313.7z"
  }), "\n&#x9;&#x9;", /*#__PURE__*/React.createElement("path", {
    id: "Letter_a_3_",
    fill: "#3C4043",
    d: "M657.9,339.1c14.2,0,25.4,3.8,33.6,11.4c8.2,7.6,12.3,18,12.3,31.2v63h-18.3v-14.2h-0.8    c-7.9,11.7-18.5,17.5-31.7,17.5c-11.3,0-20.7-3.3-28.3-10s-11.4-15-11.4-25c0-10.6,4-19,12-25.2c8-6.3,18.7-9.4,32-9.4    c11.4,0,20.8,2.1,28.1,6.3v-4.4c0-6.7-2.6-12.3-7.9-17c-5.3-4.7-11.5-7-18.6-7c-10.7,0-19.2,4.5-25.4,13.6l-16.9-10.6    C625.9,345.8,639.7,339.1,657.9,339.1z M633.1,413.3c0,5,2.1,9.2,6.4,12.5c4.2,3.3,9.2,5,14.9,5c8.1,0,15.3-3,21.6-9    s9.5-13,9.5-21.1c-6-4.7-14.3-7.1-25-7.1c-7.8,0-14.3,1.9-19.5,5.6C635.7,403.1,633.1,407.8,633.1,413.3z"
  }), "\n&#x9;&#x9;", /*#__PURE__*/React.createElement("path", {
    id: "Letter_y_3_",
    fill: "#3C4043",
    d: "M808.2,342.4l-64,147.2h-19.8l23.8-51.5L706,342.4h20.9l30.4,73.4h0.4l29.6-73.4H808.2z"
  }), "\n&#x9;"), "\n&#x9;", /*#__PURE__*/React.createElement("g", {
    id: "G_Mark_1_"
  }, "\n&#x9;&#x9;", /*#__PURE__*/React.createElement("path", {
    id: "Blue_500",
    fill: "#4285F4",
    d: "M452.93,372c0-6.26-0.56-12.25-1.6-18.01h-80.48v33L417.2,387    c-1.88,10.98-7.93,20.34-17.2,26.58v21.41h27.59C443.7,420.08,452.93,398.04,452.93,372z"
  }), "\n&#x9;&#x9;", /*#__PURE__*/React.createElement("path", {
    id: "Green_500_1_",
    fill: "#34A853",
    d: "M400.01,413.58c-7.68,5.18-17.57,8.21-29.14,8.21c-22.35,0-41.31-15.06-48.1-35.36    h-28.46v22.08c14.1,27.98,43.08,47.18,76.56,47.18c23.14,0,42.58-7.61,56.73-20.71L400.01,413.58z"
  }), "\n&#x9;&#x9;", /*#__PURE__*/React.createElement("path", {
    id: "Yellow_500_1_",
    fill: "#FABB05",
    d: "M320.09,370.05c0-5.7,0.95-11.21,2.68-16.39v-22.08h-28.46    c-5.83,11.57-9.11,24.63-9.11,38.47s3.29,26.9,9.11,38.47l28.46-22.08C321.04,381.26,320.09,375.75,320.09,370.05z"
  }), "\n&#x9;&#x9;", /*#__PURE__*/React.createElement("path", {
    id: "Red_500",
    fill: "#E94235",
    d: "M370.87,318.3c12.63,0,23.94,4.35,32.87,12.85l24.45-24.43    c-14.85-13.83-34.21-22.32-57.32-22.32c-33.47,0-62.46,19.2-76.56,47.18l28.46,22.08C329.56,333.36,348.52,318.3,370.87,318.3z"
  }), "\n&#x9;"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePayMark);
export default __webpack_public_path__ + "static/media/google-pay-mark.0b30a7b7ec9334b5a8b313aac7c1b329.svg";
export { ForwardRef as ReactComponent };